import React, { useEffect } from "react";
import s from "./technologyCardLora.module.css";
import Futter from "../futter/Futter";
import MT from "../../image/MT.png";
import WPD from "../../image/WPD.png";
import WPV from "../../image/WPV.png";
import NBIoT from "../../image/5 1.png";
import { useDispatch, useSelector } from "react-redux";
import Mult from "./Mult";
import { useNavigate } from "react-router-dom";
import {
  catalogActReducer,
  changeCurrProd,
} from "../../redux/slices/catalogSlice";
import { selectStart } from "../../redux/selectors";
import { startMult } from "../../redux/slices/navigateSlice";
import { HiOutlineChevronRight } from "react-icons/hi2";
import PageHelmet from "../PageHelmet";

const TechnologyCardNBIot = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const start = useSelector(selectStart);

  const prod = [
    ["Счетчик холодной воды крыльчатый МТ", "МТ DN15", MT, [0, 1, 0]],
    ["Счетчик холодной воды турбинный WP-D", "WP-D DN50", WPD, [0, 1, 1]],
    [
      "Счетчик холодной воды турбинный сопряженный WP-V",
      "WP-V DN50/DN15",
      WPV,
      [0, 1, 2],
    ],
    [
      "Счетчик импульсов Вега",
      "Счётчик импульсов Вега NB-11",
      NBIoT,
      [5, 0, 0],
    ],
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (start[2]) {
        let a = [...start];
        a.splice(2, 1, false);
        dispatch(startMult(a));
      }
    }, 7000);
  }, [dispatch, start]);
  const onClick = (catalog, product) => {
    dispatch(catalogActReducer(catalog));
    dispatch(changeCurrProd(product));
    navigate("/product");
  };
  const products = prod.map((el, i) => {
    return (
      <div
        onClick={() => {
          onClick(el[3], el[1]);
        }}
        key={el[1]}
        className={s.blockCatalog}
      >
        <p className={s.numberPoductCatalog}>{"0" + (i + 1)}</p>
        <p className={s.poductCatalog}>{el[0]}</p>
        <img className={s.svkh} src={el[2]} alt="" />
      </div>
    );
  });

  return (
    <div>
      <PageHelmet />
      {start[1] && !start[1] ? (
        <Mult
          close={() => {
            // убрать !start[1]
            start.splice(2, 1, false);
            dispatch(startMult(start));
          }}
          name={"picStartNBiot"}
        />
      ) : (
        <div className={s.technologyCard}>
          <div className={s.container}>
            <div className={s.blockTree}>
              <span onClick={() => navigate(-1)} className={s.item}>
                Технологии
              </span>
              <HiOutlineChevronRight />
              <span className={s.item}>NB-IoT</span>
            </div>

            <h2>
              NB-IoT - <span className={s.text11}>удаленное</span> считывание
              показаний счетчиков{" "}
            </h2>
            <div className={s.blockTop}>
              <div className={s.blockTopText}></div>
              <div className={s.blockTop}>
                <Mult name={"picNBiot"} />
              </div>
            </div>

            <h3 className={s.hArhitect}>Архитектура сети NB-IoT</h3>
            <p className={s.textArhitect}>
              Архитектура NB-IoT (Narrowband Internet of Things) основана на
              существующей инфраструктуре сотовых сетей, но оптимизирована для
              работы с устройствами Интернета вещей (IoT). Она включает
              несколько ключевых компонентов, которые обеспечивают низкое
              энергопотребление, широкое покрытие и поддержку большого числа
              устройств. Основные элементы архитектуры NB-IoT:
            </p>
            <div className={s.blockArhitect}>
              <div className={s.listArhitect}>
                <p className={s.textLeft}>Конечные устройства</p>
                <p className={s.textRight}>
                  Счетчики воды со встроенными или съемными датчиками импульсов.
                  Датчики собирают данные и затем передают их счетчику
                  импульсов.
                </p>
              </div>
              <div className={s.listArhitect}>
                <p className={s.textLeft}>Шлюз</p>
                <p className={s.textRight}>
                  Прибор, который используются для подсчета количества
                  импульсов, выдаваемых конечным устройством и передающий
                  пакетные данные передаются по протоколу UDP по отдельному,
                  независимому каналу передачи данных В устройство NB-IoT
                  вставляется SIM-карта. Устройство имеет режим Power Save Mode
                  (режим энергосбережения), в котором оно работает с
                  определенными интервалами. Оборудование передает пакеты на
                  платформу в заданное время и уходит в спящий режим, что
                  позволяет экономить заряд батареи.
                </p>
              </div>
              <div className={s.listArhitect}>
                <p className={s.textLeft}>Сетевой сервер </p>
                <p className={s.textRight}>
                  Это облачная платформа, которая собирает, обрабатывает и
                  анализирует данные от устройств NB-IoT.
                </p>
              </div>
              <div className={s.listArhitect}>
                <p className={s.textLeft}>Сервер приложений</p>
                <p className={s.textRight}>
                  Предоставляет пользовательский интерфейс и функциональность
                  для взаимодействия с IoT-системой. Здесь данные преобразуются
                  в полезные действия или визуализируются для пользователей.
                </p>
              </div>
            </div>
            <h3 className={s.hTehnology}>
              Предлагаемые компоненты системы NB-Iot:
            </h3>
            <div className={s.listCatalog}>
              {products}

              <p className={s.textTarif}>
                {" "}
                * Для организации сбора данных с приборов учета с дистанционным
                съемом ООО "ПремексБел" рекомендует приобрести: SIM-карту
                мобильного оператора МТС с тарифным планом "IoT-сеть" либо
                SIM-карту мобильного оператора А1 с тарифным планом "Телеметрия
                NBiot"
              </p>
              <p className={s.textSlogan}>
                Свяжитесь с нами для получения предложения или информации!
              </p>
            </div>
          </div>
        </div>
      )}
      {!start[2] && <Futter />}
    </div>
  );
};

export default TechnologyCardNBIot;
